<template>
  <div>
    <div v-if="arrCampaignImage && arrCampaignImage.length > 1">
      <carousel
        :responsive="objCarouselConfig.responsive"
        :margin="10"
        :lazyLoad="true"
        :loop="true"
        :autoplay="true"
      >
        <div class="detail-img" v-for="(objImage,k) in arrCampaignImage" :key="k">
          <img :src="objImage.fullImageUrl" class="img-fluid" />
        </div>
      </carousel>
    </div>
    <div class="detail-img-wrapper" v-if="arrCampaignImage && arrCampaignImage.length == 1">
        <img :src="arrCampaignImage[0].fullImageUrl" class="img-fluid" />
    </div>
  </div>
</template>

<script>
import Carousel from "vue-owl-carousel";

export default {
  name: "Picture",
  components: {
    Carousel
  },
  props: {
    arrCampaignImage: Array
  },
  //#region asdwd
  //! sdsd
  //#endregion
  data: function() {
    return {
      objCarouselConfig: {
        responsive: {
          0: { items: 1 }
        }
      }
    };
  }
};
</script>
<style lang="scss">
.img-fluid{
    height: auto;
}
.detail-img-wrapper {

    position: relative;
    width: 100%; /* desired width */
    img {
        width: 83.333%;
        height: 100%;
        position: absolute;
        top: 0;
        right: 0;
    }
    &:before {
        content: "";
        display: block;
        // padding-top: 66.66%; /* initial ratio of 1:1*/
        padding-top: 100%;
    }
}
</style>
